import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseService} from './base.service';
import {Observable} from 'rxjs';
import {AlertService} from './alert.service';
import {GlobalService} from './global.service';
import {AppUrl} from '../constants/app-url';

@Injectable({
    providedIn: 'root'
})
export class SrMappingService extends BaseService {
    constructor(public http: HttpClient,
                public alertService: AlertService,
                public globalService: GlobalService) {
        super(http, alertService, globalService);
    }

    get(data): Observable<any> {
        return this.getRequest(AppUrl.SRMAPPINGS(), data);
    }

    getReasonByStage(id, data): Observable<any> {
        return this.getRequest(AppUrl.SRMAPPINGS_BY_STAGES(id), data);
    }

    count(): Observable<any> {
        return this.getRequest(AppUrl.SRMAPPINGS_COUNT());
    }

    detail(id): Observable<any> {
        return this.getRequest(AppUrl.SRMAPPINGS(id));
    }

    create(data): Observable<any> {
        return this.postRequest(AppUrl.SRMAPPINGS(), data);
    }

    update(id, data): Observable<any> {
        return this.putRequest(AppUrl.SRMAPPINGS(id), data);
    }

    updateStatus(id, data): Observable<any> {
        return this.putRequest(AppUrl.SRMAPPINGS_STATUS(id), data);
    }
}
